import { ControllerType, Student } from '@/common/types/student';

export function getDuelSettingsConfig(student: Student) {
  return {
    optionStatuses: [
      {
        option: 'dragNDrop',
        value: student.settings.controllerType === ControllerType.DRAG,
        enabled: false,
        hoverMessage: `Drag & Drop disabled for duels.`,
      },
      {
        option: 'playPhonemeOnCardDrop',
        value: student.settings.controllerType === ControllerType.KEYBOARD,
        enabled: false,
        hoverMessage: `Play phoneme on card drop disabled for duels.`,
      },
      {
        option: 'wordSegmentation',
        value: student.settings.wordSegmentationEnabled,
        enabled: false,
        hoverMessage: `Word segmentation disabled for duels.`,
      },
      {
        option: 'articulatoryGestures',
        value: student.settings.articulatoryGesturesEnabled,
        enabled: false,
        hoverMessage: `Articulatory gestures disabled for duels.`,
      },
    ],
  };
}

export function getAssessmentSettingsConfig(student: Student) {
  return {
    optionStatuses: [
      {
        option: 'music',
        value: student.settings.audio.musicOn,
        enabled: false,
        hoverMessage: 'Controls disabled for assessment.',
      },
      {
        option: 'sfx',
        value: student.settings.audio.sfxOn,
        enabled: false,
        hoverMessage: 'Controls disabled for assessment.',
      },
      {
        option: 'clickToPlace',
        value: student.settings.controllerType === ControllerType.CLICK,
        enabled: false,
        hoverMessage: 'Controls disabled for assessment.',
      },
      {
        option: 'dragNDrop',
        value: student.settings.controllerType === ControllerType.DRAG,
        enabled: false,
        hoverMessage: 'Controls disabled for assessment.',
      },
      {
        option: 'keyboard',
        value:
          student.settings.controllerType === ControllerType.KEYBOARD || false,
        enabled: false,
        hoverMessage: 'Controls disabled for assessment.',
      },
    ],
  };
}
